import { createFileRoute } from '@tanstack/react-router';
import { SellersPage } from '../../../pages/SellersPage';
import { ensureCatalogEntries } from '../../../features/catalog/queries';
import { loadSellers } from '../../../features/sellers/queries';
import { staticPageHead } from '../../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/sellers/')({
  head: () =>
    staticPageHead({
      path: '/sellers',
      title: 'Marketplace Sellers - AnyAPI',
      description:
        'The independent marketplace sellers AnyAPI has approved to fulfill requests, and the endpoints each one serves.',
      crumb: 'Marketplace sellers',
      // Seller pages are kept out of search results by product decision
      // (2026-10-27) and out of the sitemap (lib/seo/sitePages.ts). Crawlable so
      // the noindex is seen, `follow` so the seller page links still resolve.
      robots: 'noindex, follow',
    }),
  // The list is the page, so it is resolved before the page renders and reaches
  // a crawler or a reader with no JavaScript. The page renders per request, never
  // prerendered (scripts/prerenderScope.ts RUNTIME_PATHS), so that list is live.
  loader: ({ context }) =>
    Promise.all([ensureCatalogEntries(context.queryClient), loadSellers(context.queryClient)]),
  component: SellersPage,
});
